import React from 'react';
import {useAuth} from '../../context/auth';
import MinimalLayout from "../../layouts/minimal";

export default function NotFound () {

  return (
    <div className={"container-fluid vh-100 d-flex align-items-center"}>
      <div className={"col text-center align-items-center align-content-center"}>
        <h1 className="py-8">Stránka nebola nájdená.</h1>
        <p className="text-grey-dark">
          Skúste si skontrolovať adresu.
        </p>
      </div>
    </div>
  );
}

NotFound.getLayout = function getLayout(page) {
  return (
    <MinimalLayout>
      {page}
    </MinimalLayout>
  )
}

NotFound.getSEO = function getSEO() {
  return {
    title: "404 - Stránka neexistuje",
  }
}
